import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconPackageValidation from '@/icons/PackageValidation.svg';

export const ShipmentIssueResolvedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'shipment_issue_resolved'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator.name;

  return (
    <BaseActivity
      key={activity.id}
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconPackageValidation />}
      message={
        <>
          <BaseActivityText>
            <Trans id="activities.shipment_issue_resolved.message">
              <strong>{creatorName}</strong> resolved a shipment issue on the item
            </Trans>
          </BaseActivityText>
          <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
        </>
      }
    >
      {!!activity.data.issueResolution && (
        <BaseActivityDetailedContent>{activity.data.issueResolution}</BaseActivityDetailedContent>
      )}
    </BaseActivity>
  );
};
